import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { withAuthenticator } from './aws-amplify-react/Auth/index';
import asyncComponent from './components/AsyncComponent';
const GoodStandingCertificate = asyncComponent(() => import('./letters/GoodStandingCertificate'));
const GoodStandingCertificateArabic = asyncComponent(() => import('./letters/GoodStandingCertificateArabic'));
const MedicalDirector = asyncComponent(() => import('./letters/MedicalDirector'));
const PartTimePractice = asyncComponent(() => import('./letters/PartTimePractice'));
const PreMaritalApproval = asyncComponent(() => import('./letters/PreMaritalApproval'));
const VisitingConsultant = asyncComponent(() => import('./letters/VisitingConsultantConditional'));
const VisitingConsultantConditional = asyncComponent(() => import('./letters/VisitingConsultantConditional'));
const RequestForRecognition = asyncComponent(() => import('./letters/RequestForRecognition'));
const VisitingConsultantLicense = asyncComponent(() => import('./letters/VisitingConsultantLicense'));
const Lmra = asyncComponent(() => import('./letters/Lmra'));
const licenseCard = asyncComponent(() => import('./letters/licenseCard'));
const RenewalReminder = asyncComponent(() => import('./email-templates/RenewalReminder'));
const SecondLicenseCard = asyncComponent(() => import('./letters/SecondLicenseCard'));
const QrcodeVerify = asyncComponent(() => import('./QrCode/QrcodeVerify'));

const AppPayments = asyncComponent(() => import('./appPayments/index'));

const ProfessionAddlServiceLicenseRenewal = asyncComponent(() => import('./pages/ProfessionAddlService/LicenseRenewal'));
const ProfessionAddlServiceOtherServices = asyncComponent(() => import('./pages/ProfessionAddlService/OtherServices'));
const ProfessionAddlServiceOtherServices1 = asyncComponent(() => import('./pages/ProfessionAddlService/OtherServices'));
const ProfessionAddlServiceOtherServices2 = asyncComponent(() => import('./pages/ProfessionAddlService/OtherServices'));
const ProfessionAddlServiceOtherServices3 = asyncComponent(() => import('./pages/ProfessionAddlService/OtherServices'));
const ProfessionAddlServiceVisitingConsultant = asyncComponent(() => import('./pages/ProfessionAddlService/VisitingConsultant'));
const ProfessionAddlServiceReCategorization = asyncComponent(() => import('./pages/ProfessionAddlService/ReCategorization'));
const ProfessionApplicationMoreInfoUpdate = asyncComponent(() => import('./pages/ProfessionAddlService/ApplicationMoreInfoUpdate'));
const Facility = asyncComponent(() => import('./pages/Facility'));
const PaymentProcess = asyncComponent(() => import('./pages/PaymentProcess'));
const PaymentResult = asyncComponent(() => import('./pages/PaymentProcess/PaymentResult'));
const Dashboard = asyncComponent(() => import('./pages/Dashboard'));
const ProfessionDashboard = asyncComponent(() => import('./pages/Dashboard/profession-dashboard.js'));
const FacilityDashboard = asyncComponent(() => import('./pages/Dashboard/facility-dashboard.js'));
const Professional = asyncComponent(() => import('./pages/Profession'));
const ProfessionLicenseExamUpdate = asyncComponent(() => import('./pages/ProfessionAddlService/LicenseExamUpdate'));
const ApplicationExtraInfoUpdate = asyncComponent(() => import('./pages/ProfessionAddlService/ApplicationExtraInfoUpdate'));
const test = asyncComponent(() => import('./pages/test'));
const ManageProfile = asyncComponent(() => import('./pages/Dashboard/ManageProfile'));
const UpdateUserDetails = asyncComponent(() => import('./pages/Dashboard/ManageProfile/UpdateUserDetails'));
const CustomChangePassword = asyncComponent(() => import('./pages/Dashboard/ManageProfile/CustomChangePassword'));
const ProfessionAddlServiceGoodstanding = asyncComponent(() => import('./pages/ProfessionAddlService/GoodStanding/index'));
const ProfessionAddlServiceCombinedServices = asyncComponent(() => import('./pages/ProfessionAddlService/CombinedServices/index'));
const ProfessionAddlServicePharmacyManager = asyncComponent(() => import('./pages/ProfessionAddlService/PharmacyManager/index'));
const ProfessionAddlServiceHajpermit = asyncComponent(() => import('./pages/ProfessionAddlService/HajPermit/index'));
const ProfessionAddlServicePremaritalpermit = asyncComponent(() => import('./pages/ProfessionAddlService/Premaritalpermit/index'));
const ProfessionAddlServiceRequestletters = asyncComponent(() => import('./pages/ProfessionAddlService/Requestletters/index'));
const ProfessionAddlServiceUpdateinfo = asyncComponent(() => import('./pages/ProfessionAddlService/Updateuserinfo/index'));
const ProfessionAddlServiceTelemedicine = asyncComponent(() => import('./pages/ProfessionAddlService/Telemedicine/index'));
const ProfessionAddlServiceUpdatecpd = asyncComponent(() => import('./pages/ProfessionAddlService/Updatecpd/index'));

class RoutesUnAuth extends React.Component {
  render() {
    // console.log("this.props", this.props);
    // console.log("this.state", this.state);
    return (
      <Switch>
        <Route exact path='/' component={Dashboard} />
        <Route exact path='/QrCode/QrcodeVerify' component={QrcodeVerify} />
        <Route exact path='/app/paymentsuccess' component={AppPayments} />
        <Route exact path='/app/paymentcancel' component={AppPayments} />
        <Route exact path='/app/paymentfailure' component={AppPayments} />
      </Switch>
    )
  }
};

export default RoutesUnAuth;

